import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Form/Button';
import { useAction } from 'hooks';
import App from 'modules/App';
import * as selectors from '../../../selectors';
const Actions = ()=>{
    const isInProgress = useSelector(selectors.isMergePatientInProgress);
    const onCloseModal = useAction(App.actions.closeModal);
    return /*#__PURE__*/ _jsx("div", {
        className: "modal__actions modal__actions--fixHeight",
        children: !isInProgress ? /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: App.messages.buttons.close,
            className: "btn--block btn--filled",
            onClick: onCloseModal
        }) : null
    });
};
export default Actions;
